module.exports = __webpack_public_path__ + "static/media/oberflex-acajout19-2560x1440.92b8c6c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-acajout19-2560x1440.jpg
// module id = 969
// module chunks = 37